import React, { useState } from "react";
import Lightbox from "react-awesome-lightbox";
import "react-awesome-lightbox/build/style.css";

const GalleryP = () => {
  const images = [
    //1//
    {
      src: "/img/portfolio/portrait/01/gtcoxfenqtgloqe3rfkx_compression.jpg",
      alt: "Photo 1",
      category: "Portrait",
    },
    {
      src: "/img/portfolio/portrait/01/wrzkoexu80kgz53pji1p_compression.jpg",
      alt: "Photo 2",
      category: "Portrait",
    },
    {
      src: "/img/portfolio/portrait/01/ysu8xvoegyzsl2cqxkup_compression.jpg",
      alt: "Photo 3",
      category: "Portrait",
    },

    //2//
    {
      src: "/img/portfolio/portrait/00/otldf4rmbo9aks0zdi5q_compression.jpg",
      alt: "Photo 4",
      category: "Portrait",
    },
    {
      src: "/img/portfolio/portrait/00/zmf5umplrqhjobgfau5z_compression.jpg",
      alt: "Photo 5",
      category: "Portrait",
    },
    {
      src: "/img/portfolio/portrait/00/jyt6l6zkj0vy6c1tqq9f_compression.jpg",
      alt: "Photo 6",
      category: "Portrait",
    },
    //3//
    {
      src: "/img/portfolio/RECADRAGE/lrdznqrsdnprokktdu26_compression.jpg",
      alt: "Photo 7",
      category: "Portrait",
    },
    {
      src: "/img/portfolio/portrait/02/uoib692s630flh64p58u_compression.jpg",
      alt: "Photo 8",
      category: "Portrait",
    },
    {
      src: "/img/portfolio/portrait/02/edz3gwmfwvfzzursmekt_compression.jpg",
      alt: "Photo 9",
      category: "Portrait",
    },
    //4//

    {
      src: "/img/portfolio/portrait/03/rx2in1ezy46tgpab90k7_compression.jpg",
      alt: "Photo 10",
      category: "Portrait",
    },
    {
      src: "/img/portfolio/portrait/03/jstxbtnu058rplmt4nhj_compression.jpg",
      alt: "Photo 11",
      category: "Portrait",
    },
    {
      src: "/img/portfolio/RECADRAGE/sefzyucpnnhwzbd48oe2_compression.jpg",
      alt: "Photo 12",
      category: "Portrait",
    },
    //5//
    {
      src: "/img/portfolio/portrait/04/lgluleyki8volbreyryx_compression.jpg",
      alt: "Photo 13",
      category: "Portrait",
    },

    {
      src: "/img/portfolio/portrait/04/gaa8oauti0k40ixpbtaf_compression.jpg",
      alt: "Photo 14",
      category: "Portrait",
    },
    {
      src: "/img/portfolio/portrait/04/creajzx4wglzxsbp4qu7_compression.jpg",
      alt: "Photo 15",
      category: "Portrait",
    },

    //6//
    {
      src: "/img/portfolio/portrait/5/fjeiugscc5w44qi09szm_compression.jpg",
      alt: "Photo 16",
      category: "Portrait",
    },
    {
      src: "/img/portfolio/portrait/5/svf3dqfbqfzi3lj1svtx_compression.jpg",
      alt: "Photo 17",
      category: "Portrait",
    },

    {
      src: "/img/portfolio/portrait/5/o0wqlffb0hbi2jedn62v_compression.jpg",
      alt: "Photo 18",
      category: "Portrait",
    },
    //7//
    {
      src: "/img/portfolio/portrait/05/kvl4u9ggq2jjlie4zgc1_compression.jpg",
      alt: "Photo 19",
      category: "Portrait",
    },
    {
      src: "/img/portfolio/portrait/gjgbpltxrqe5hpedpjlw_compression.jpg",
      alt: "Photo 20",
      category: "Portrait",
    },
    {
      src: "/img/portfolio/portrait/05/f9rwafmwcgavayianuzw_compression.jpg",
      alt: "Photo 21",
      category: "Portrait",
    },
  ];

  const [isOpen, setIsOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);

  return (
    <>
      {/* Section Header */}
      <section
        className="banner-header banner-img banner-img-top section-padding valign bg-img bg-fixed banner-overlay"
        data-overlay-darkgray="1"
        style={{
          backgroundImage:
            "url('/img/portfolio/portrait/gjgbpltxrqe5hpedpjlw_compression.jpg')",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-md-5">
              <h1>Portrait</h1>
              <hr className="border-1 text-white" />
              <p>
                Explorez notre collection de portraits capturant des moments
                uniques et des expressions authentiques.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Section Portfolio */}
      <section className="projects2 section-padding bg-blck">
        <div className="container">
          <div className="row">
            {images.map((image, index) => (
              <div
                key={index}
                className="col-12 col-md-4 portfolio-masonry-wrapper-padding"
              >
                <div className="portfolio-item-wrapp">
                  <div
                    className="portfolio-item"
                    onClick={() => {
                      setPhotoIndex(index);
                      setIsOpen(true);
                    }}
                  >
                    <div className="portfolio-masonry-wrapper">
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="img-fluid portfolio-masonry-item-img"
                      />
                      <div
                        className="portfolio-masonry-item-content"
                        style={{
                          marginTop: "5px", // Optionnel : ajuster l'espacement du texte
                        }}
                      >
                        <div className="portfolio-masonry-item-category">
                          {image.category}
                        </div>
                        <h4 className="portfolio-masonry-item-title">
                          {image.title}
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Lightbox */}
        {isOpen && (
          <Lightbox
            images={images.map((img) => ({ url: img.src, title: img.title }))}
            startIndex={photoIndex}
            onClose={() => setIsOpen(false)}
          />
        )}
      </section>
    </>
  );
};

export default GalleryP;
